import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon/Icon';
import './progress.scss';

const progressStatus = ['default', 'loading', 'success', 'error'];
progressStatus.getStatusIndex = (status) => {
  return progressStatus.indexOf(status);
};

const propTypes = {
  text: PropTypes.string,
  status: PropTypes.oneOf(progressStatus),
  showLoading: PropTypes.bool,
  success: PropTypes.string,
  error: PropTypes.string,
  // 是否允许状态回退
  canBack: PropTypes.bool,
  // 是否显示前缀，类似list-style square
  hasPre: PropTypes.bool
};

const defaultProps = {
  text: '',
  status: 'default',
  showLoading: true,
  canBack: false,
  hasPre: false
};

export default class Progress extends Component {
  constructor() {
    super();
    this.getText = this.getText.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    const isBack = progressStatus.getStatusIndex(nextProps.status)
      < progressStatus.getStatusIndex(this.props.status);
    if (!this.props.canBack && isBack) {
      /* eslint-disable no-console */
      console.error('进度不允许回退，请修改props属性canBack');
      return false;
    }

    return true;
  }

  getText() {
    const { text, status, success, error } = this.props;

    switch (status) {
      case 'default':
      case 'loading':
        return text;
      case 'success':
        return success || text;
      case 'error':
        return error || text;
      default:
        return text;
    }
  }

  render() {
    const {
      status,
      showLoading,
      hasPre,
      className,
      children,
      wrapStyle,
      small
    } = this.props;

    const icon = (function getIcon() {
      let suffix = '';
      switch (status) {
        case progressStatus[1]:
          suffix = showLoading ? 'loading' : '';
          break;
        case progressStatus[2]:
          suffix = 'dui1-copy-copy';
          break;
        case progressStatus[3]:
          suffix = 'cuo';
          break;
        default:
          break;
      }

      return suffix ? (
        <Icon
          icon={suffix}
          className={['progress__icon', `progress__icon--${status}`].join(' ')}
        />
      ) : '';
    }());

    return (
      <div
        className={
          [
            'progress-container',
            hasPre ? 'progress-container--pre' : '',
            small ? 'progress-container--small' : '',
            className
          ].join(' ')
        }
        style={wrapStyle}
      >
        <div className="progress__text">
          {this.getText()}
          {children}
        </div>
        {icon}
      </div>
    );
  }
}

Progress.propTypes = propTypes;
Progress.defaultProps = defaultProps;
